import React from "react";
import { UserCheck } from "lucide-react";

/**
 * Small side-by-side thumb that reassures the user their face + figure survived
 * the AI generation. Compares the original portrait against the try-on result.
 *
 * Kept intentionally subtle — narrow strip, muted background, tiny caption.
 * Only rendered when we have both a source photo and a generated result.
 */
export const IdentityCheck = ({ beforeUrl, afterUrl }) => {
  if (!beforeUrl || !afterUrl) return null;
  return (
    <div
      data-testid="identity-check"
      className="mt-4 border border-black/10 bg-[#F1EFE7] p-3 flex items-center gap-3"
    >
      <UserCheck className="w-4 h-4 shrink-0 text-[color:var(--accent)]" />
      <div className="flex items-center gap-2 shrink-0">
        <div className="w-12 h-16 overflow-hidden border border-black/10 bg-white">
          <img
            data-testid="identity-check-before"
            src={beforeUrl}
            alt="original"
            className="w-full h-full object-cover"
          />
        </div>
        <span className="font-mono-eyebrow text-[9px] text-black/40">→</span>
        <div className="w-12 h-16 overflow-hidden border border-black/10 bg-white">
          <img
            data-testid="identity-check-after"
            src={afterUrl}
            alt="try-on"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-mono-eyebrow text-[10px]">Identity check</div>
        <div className="text-[11px] text-black/60 leading-tight mt-0.5">
          Same face. Same figure. Only the clothes changed.
        </div>
      </div>
    </div>
  );
};
